/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreOpsAnswerListUpdate
 */
export interface PreOpsAnswerListUpdate {
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerListUpdate
     */
    userFullName?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerListUpdate
     */
    vehicleSerialNumber?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerListUpdate
     */
    departmentLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerListUpdate
     */
    preOpsChecklistLabel?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerListUpdate
     */
    preOpsQuestionBody?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof PreOpsAnswerListUpdate
     */
    preOpsAnswerChoice?: boolean | null;
}

/**
 * Check if a given object implements the PreOpsAnswerListUpdate interface.
 */
export function instanceOfPreOpsAnswerListUpdate(value: object): value is PreOpsAnswerListUpdate {
    return true;
}

export function PreOpsAnswerListUpdateFromJSON(json: any): PreOpsAnswerListUpdate {
    return PreOpsAnswerListUpdateFromJSONTyped(json, false);
}

export function PreOpsAnswerListUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsAnswerListUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'userFullName': json['userFullName'] == null ? undefined : json['userFullName'],
        'vehicleSerialNumber': json['vehicleSerialNumber'] == null ? undefined : json['vehicleSerialNumber'],
        'departmentLabel': json['departmentLabel'] == null ? undefined : json['departmentLabel'],
        'preOpsChecklistLabel': json['preOpsChecklistLabel'] == null ? undefined : json['preOpsChecklistLabel'],
        'preOpsQuestionBody': json['preOpsQuestionBody'] == null ? undefined : json['preOpsQuestionBody'],
        'preOpsAnswerChoice': json['preOpsAnswerChoice'] == null ? undefined : json['preOpsAnswerChoice'],
    };
}

export function PreOpsAnswerListUpdateToJSON(json: any): PreOpsAnswerListUpdate {
    return PreOpsAnswerListUpdateToJSONTyped(json, false);
}

export function PreOpsAnswerListUpdateToJSONTyped(value?: PreOpsAnswerListUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userFullName': value['userFullName'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'departmentLabel': value['departmentLabel'],
        'preOpsChecklistLabel': value['preOpsChecklistLabel'],
        'preOpsQuestionBody': value['preOpsQuestionBody'],
        'preOpsAnswerChoice': value['preOpsAnswerChoice'],
    };
}

